import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import firebase from 'firebase/app';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private cloudFunctionUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

  async getPaymentById(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const fileRef = firebase.firestore().collection('payments');
      const query = fileRef
        .where('id', '==', id)
        .limit(1)
        .get();

      query.then((item) => {
        if (item.empty) {
          resolve(null);
          return;
        }

        const array = [];
        for (let doc of item.docs) {
          array.push(doc.data());
        }

        Promise.all(array).then((response) => {
          resolve(response);
        });

      }).catch((error) => {
        console.log("Error getting document:", error);
        reject(error);
      });
    });
  }

  async getOnlinePaymentByCheckoutId(checkoutId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const fileRef = firebase.firestore().collection('online_payments');
      const query = fileRef
        .where('checkout_id', '==', checkoutId)
        .limit(1)
        .get();

      query.then((item) => {
        if (item.empty) {
          resolve(null);
          return;
        }

        const doc = item.docs[0];
        resolve({
          id: doc.id,
          ...doc.data()
        });

      }).catch((error) => {
        console.log("Error getting online payment:", error);
        reject(error);
      });
    });
  }

  async verifyPaymentStatus(checkoutId: string): Promise<any> {
    try {
      // First check our online_payments collection
      const onlinePayment = await this.getOnlinePaymentByCheckoutId(checkoutId);
      
      if (!onlinePayment) {
        throw new Error('Payment record not found');
      }

      // If payment is already marked as paid, return success
      if (onlinePayment.status === 'paid' || onlinePayment.status === 'completed') {
        return {
          success: true,
          status: 'paid',
          payment: onlinePayment
        };
      }

      // Call cloud function to verify with PayMaya and update records
      const response = await this.http.post(`${this.cloudFunctionUrl}/verifyPaymentStatus`, {
        checkout_id: checkoutId,
        payment_record_id: onlinePayment.id
      }).toPromise();

      return response;

    } catch (error) {
      console.error('Error verifying payment status:', error);
      throw error;
    }
  }

  async processPaymentWebhook(webhookData: any): Promise<any> {
    try {
      // Call cloud function to process webhook and update both collections
      const response = await this.http.post(`${this.cloudFunctionUrl}/processPaymentWebhook`, webhookData).toPromise();
      return response;
    } catch (error) {
      console.error('Error processing payment webhook:', error);
      throw error;
    }
  }

  async updateParkingSessionPayment(sessionId: string, paymentData: any): Promise<any> {
    try {
      // Call cloud function to update parking logs collection
      const response = await this.http.post(`${this.cloudFunctionUrl}/updateParkingSessionPayment`, {
        session_id: sessionId,
        payment_data: paymentData
      }).toPromise();
      return response;
    } catch (error) {
      console.error('Error updating parking session payment:', error);
      throw error;
    }
  }
}
